<template>
  <v-container fluid class="pa-0" style="height: 100vh; overflow: hidden; background-color: #F4F7FE;">
    <v-row no-gutters style="height: 100%;">
      
      <v-col cols="12" md="6" class="d-flex flex-column align-center justify-center px-10 bg-white" style="height: 100vh;">
        <div style="max-width: 420px; width: 100%;">
          <h1 class="text-h3 font-weight-bold mb-2" style="color: #1B2559;">Iniciar sesión</h1>
          <p class="text-body-1 mb-8" style="color: #A3AED0;">¡Introduce tu email y contraseña!</p>

          <v-form @submit.prevent="iniciarSesion">
            <label class="text-subtitle-2 font-weight-bold mb-2 d-block" style="color: #1B2559;">Correo electrónico*</label>
            <v-text-field
              v-model="usuario"
              placeholder="admin@livefit.com"
              variant="outlined"
              class="mb-4 input-final"
              bg-color="#F4F7FE"
              density="comfortable"
              hide-details
            ></v-text-field>

            <label class="text-subtitle-2 font-weight-bold mb-2 d-block" style="color: #1B2559;">Contraseña*</label>
            <v-text-field
              v-model="password"
              placeholder="Mínimo 8 caracteres"
              :type="mostrarPass ? 'text' : 'password'"
              :append-icon="mostrarPass ? 'mdi-eye' : 'mdi-eye-off'"
              variant="outlined"
              class="mb-8 input-final"
              bg-color="#F4F7FE"
              density="comfortable"
              hide-details
              @click:append="mostrarPass = !mostrarPass"
            ></v-text-field>

            <v-btn block color="#4318FF" height="50" class="text-none white--text font-weight-bold" style="border-radius: 12px;" @click="iniciarSesion">
              Iniciar sesión
            </v-btn>
          </v-form>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="d-none d-md-flex">
        <v-img
          src="/static/img/gym-login.png" 
          cover
          style="border-bottom-left-radius: 80px; height: 100vh;"
          position="20%" 
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HttpService from '../../Servicios/HttpService'

export default {
  name: "Login",
  data: () => ({
    usuario: "",
    password: "",
    mostrarPass: false 
  }),
  methods: {
    iniciarSesion() {
      let payload = {
        metodo: "login",
        usuario: { usuario: this.usuario, password: this.password }
      };
      HttpService.obtenerConDatos(payload, "usuarios.php").then(resultado => {
        if (resultado.resultado) { 
            localStorage.setItem("idUsuario", resultado.datos.idUsuario);
            localStorage.setItem("nombreUsuario", resultado.datos.nombreUsuario);
            localStorage.setItem("rol", resultado.datos.rol); 
            this.$emit("logeado", resultado); 
        } else {
            alert("Usuario o contraseña incorrectos");
        }
      });
    }
  }
}
</script>

<style scoped>
.input-final.v-input :deep(input::placeholder) {
  color: #333333 !important;
  -webkit-text-fill-color: #333333 !important;
  opacity: 1 !important;
}

.input-final.v-input :deep(input) {
  color: #000000 !important;
}

.input-final :deep(.v-icon) {
  color: #1B2559 !important;
  cursor: pointer;
}

html, body { height: 100vh; overflow: hidden !important; }
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/Login.vue